import { Tooltip } from './styles'

export function CustomTooltip({ children, ...rest }) {
  return (
    <Tooltip {...rest}>
      <div className="label">{rest.label}</div>
      <div className="tooltip">{children}</div>
    </Tooltip>
  )
}
